import { computed, inject, Injectable, resource, signal } from '@angular/core';
import { SsbConfig } from '@features/ssb-konfiguration/ssb-config.model';
import { StmPropertyApi } from '@features/ssb-konfiguration/stm-property.api';

@Injectable({
  providedIn: 'root',
})
export class SsbKonfigService {
  stmPropertyApi = inject(StmPropertyApi);

  type = signal<string | undefined>(undefined);
  noegle = signal<string | undefined>(undefined);
  vaerdi = signal<string | undefined>(undefined);

  data = resource({
    loader: async ({ abortSignal }) => {
      return await this.stmPropertyApi.getList(
        {
          sortBy: 'noegle',
        },
        abortSignal
      );
    },
  });

  output = computed((): SsbConfig[] => {
    const list = this.data.value()?.data || [];
    return list.filter(
      (x) =>
        (x.type === this.type() || !this.type()) &&
        x.noegle?.toLowerCase().includes(this.noegle()?.toLowerCase() || '') &&
        x.vaerdi?.toLowerCase().includes(this.vaerdi()?.toLowerCase() || '')
    );
  });

  resetParams() {
    this.type.set(undefined);
    this.noegle.set(undefined);
    this.vaerdi.set(undefined);
  }
}
